import styled from 'styled-components'

export const Path = styled.code`
	overflow-wrap: anywhere;
	max-width: max-content;
`
